<div class="userrow card gap-12 col w100" i18n>
    <div class="lane1">
        <div class="col gap-8">
            <div class="row gap-8">
                <rr-badge tone="brand">NEW</rr-badge>
                <div class="strong">
                    {{ invitee.data.anrede }} {{ invitee.data.prename }}
                    {{ invitee.data.lastname }}
                </div>
            </div>
            <div>{{ invitee.email }} | Invited: {{ invitee.created | date }}</div>
        </div>
        <div class="btnarea row gap-8 align-center">
            <rr-btn type="link" size="small" (click)="declineInvite(invitee.id)">Decline</rr-btn>
            <rr-btn type="primary" size="Small" (click)="activateUser(invitee)">Grant Access</rr-btn>
        </div>
    </div>
    <rr-divider></rr-divider>
    <div class="lane2">
        <rr-badge tone="warning">Access Status: Pending</rr-badge>
    </div>
</div>
